import {createBalloonLayout} from "../layouts/createBalloonLayout";
import {createIconLayout} from "../layouts/createIconLayout";

export const createMarkers = (dataMarkers) => {
	const markers = dataMarkers.map((markerData) => {
		const marker = {
			type: `Feature`,
			id: markerData.id,
			geometry: {
				type: `Point`,
				coordinates: [markerData.latitude, markerData.longitude],
			},
			properties: {
				hrefImage: markerData.icon,
				group: markerData.group,
				size: {
					width: markerData.iconWidth,
					height: markerData.iconHeight,
				},

				complex: markerData.complex,
			},
			options: {
				iconLayout: createIconLayout(),
				// iconLayout: `default#image`,
				// iconImageHref: markerData.icon,
				// iconImageSize: [markerData.iconWidth, markerData.iconHeight],
				// iconImageOffset: [markerData.iconAnchorX, markerData.iconAnchorY],
				openBalloonOnClick: false,
				hideIconOnBalloonOpen: false,
				balloonShadow: false,
				balloonPanelMaxMapArea: 0,
			}
		};
		
		if (markerData.markup)
		{
			marker.properties.balloonContent = markerData.markup;
			marker.options.balloonLayout = createBalloonLayout();
		}
		
		return marker;
	});
	
	return markers;
};
